import type { NavigationItem } from "./util";

import {
  FaTachometerAlt,
  FaUserCircle,
  FaClipboardList,
  FaHourglassHalf,
  FaQuestionCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaSearchLocation,
  FaListAlt,
  FaExchangeAlt,
  FaFileSignature,
  FaMoneyBillWave,
  FaPaperPlane,
  FaUniversity,
  FaBuilding,
  FaUserTag,
  FaUsersCog,
  FaMapMarkedAlt,
  FaUserShield,
  FaCogs,
  FaTasks,
  FaFolderOpen,
  FaHome,
  FaShieldAlt,
  FaRegFileAlt,
  FaUsers,
  FaUserLock,
  FaStopwatch,
  FaUserEdit,
  FaLandmark,
} from "react-icons/fa";

import {
  MdOutlineManageAccounts,
  MdPendingActions,
  MdOutlineAssignmentReturned,
} from "react-icons/md";

import { BsBuilding, BsPeopleFill } from "react-icons/bs";

export const adminLinks: NavigationItem[] = [
  {
    id: "dashboard",
    route: "/app/dashboard",
    name: "Dashboard",
    Icon: FaTachometerAlt,
    allowed: ["Default", "Super Admin"],
  },
  {
    id: "profile",
    route: "/app/profile",
    name: "Profile",
    Icon: FaUserCircle,
    allowed: ["Default"],
  },

  {
    id: "loan-request",
    route: "#",
    name: "Loan Request",
    Icon: FaClipboardList,
    matchRoutes: ["/app/loan/*"],
    children: [
      {
        id: "loan-request-pending",
        route: "/app/loan/pending",
        name: "Pending Request",
        Icon: FaHourglassHalf,
      },
      {
        id: "loan-request-queried",
        route: "/app/loan/queried",
        name: "Queried Loans",
        Icon: FaQuestionCircle,
      },
      {
        id: "loan-request-approved",
        route: "/app/loan/approved",
        name: "Approved Request",
        Icon: FaCheckCircle,
      },
      {
        id: "loan-request-declined",
        route: "/app/loan/declined",
        name: "Declined Request",
        Icon: FaTimesCircle,
      },
      {
        id: "loan-request-track",
        route: "/app/loan/track",
        name: "Track Loan",
        Icon: FaSearchLocation,
      },
      {
        id: "loan-request-all",
        route: "/app/loan/all",
        name: "All Loan Request",
        Icon: FaListAlt,
      },
    ],
    allowed: ["Default", "Super Admin"],
  },
  {
    id: "loan-request-approval-transfer",
    route: "/app/loan/approval-transfer",
    name: "Move Approval",
    Icon: FaExchangeAlt,
    allowed: ["Super Admin"],
  },
  {
    id: "disbursement",
    name: "Disbursement",
    Icon: FaMoneyBillWave,
    allowed: ["Default", "Super Admin"],
    matchRoutes: ["/app/loan/disbursement/view/*"],
    children: [
      {
        id: "disbursement-offer-letter",
        route: "/app/disbursement",
        name: "Offer Letter",
        Icon: FaFileSignature,
      },
      {
        id: "disbursement-pending",
        route: "/app/disbursement/pending",
        name: "Pending Disbursement",
        Icon: FaHourglassHalf,
      },
      {
        id: "disbursement-queried",
        route: "/app/disbursement/queried",
        name: "Queried Disbursement",
        Icon: MdPendingActions,
      },
      {
        id: "disbursement-ongoing",
        route: "/app/disbursement/all",
        name: "On-going Disbursement",
        Icon: FaMoneyBillWave,
      },
      {
        id: "disbursement-disbursed",
        route: "/app/disbursement/disbursed",
        name: "Disbursed",
        Icon: FaPaperPlane,
      },
    ],
  },

  {
    id: "branch",
    route: "/app/branch",
    name: "Branch",
    Icon: BsBuilding,
    allowed: ["Super Admin"],
  },
  {
    id: "bank",
    route: "/app/bank",
    name: "Bank",
    Icon: FaUniversity,
    allowed: ["Super Admin"],
  },
  {
    id: "roles",
    route: "/app/roles",
    name: "Roles",
    Icon: FaUserTag,
    allowed: ["Super Admin"],
  },
  {
    id: "groups",
    route: "/app/groups",
    name: "Groups",
    Icon: FaUsersCog,
    allowed: ["Super Admin"],
  },
  {
    id: "zones",
    route: "/app/zone",
    name: "Zones",
    Icon: FaMapMarkedAlt,
    allowed: ["Super Admin"],
  },
  {
    id: "admin",
    route: "/app/admin",
    name: "Admin",
    Icon: FaUserShield,
    allowed: ["Super Admin"],
  },

  {
    id: "loan-configuration",
    route: "#",
    name: "Loan Configuration",
    Icon: FaCogs,
    allowed: ["Super Admin"],
    children: [
      {
        id: "loan-configuration-loan-type",
        route: "/app/config/loantype",
        name: "Loan Type",
        Icon: FaTasks,
      },
      {
        id: "loan-configuration-checklist",
        route: "/app/config/checklist",
        name: "Checklist",
        Icon: FaClipboardList,
      },
      {
        id: "loan-configuration-document",
        route: "/app/config/document",
        name: "Document",
        Icon: FaFolderOpen,
      },
      {
        id: "loan-configuration-facility-type",
        route: "/app/facilityType",
        name: "Facility Type",
        Icon: FaHome,
      },
      {
        id: "loan-configuration-collateral-type",
        route: "/app/collateralType",
        name: "Collateral Type",
        Icon: FaBuilding,
        allowed: ["Super Admin"],
      },
      {
        id: "loan-configuration-security-mode",
        route: "/app/modeOfSecurity",
        name: "Mode of Security",
        Icon: FaShieldAlt,
        allowed: ["Super Admin"],
      },
    ],
  },
  {
    id: "approval-configuration",
    route: "/app/approval/config",
    name: "Approval Configuration",
    Icon: FaUserShield,
    allowed: ["Super Admin"],
    matchRoutes: ["/app/approval/config/*"],
  },
  {
    id: "disbursement-configuration",
    route: "/app/disbursement/config",
    name: "Disbursement Configuration",
    Icon: FaMoneyBillWave,
    allowed: ["Super Admin"],
    matchRoutes: ["/app/disbursement/config/*"],
  },
  {
    id: "audit-log",
    route: "/app/audit",
    name: "Audit Log",
    Icon: FaRegFileAlt,
    allowed: ["Audit"],
  },
  {
    id: "customers",
    route: "/app/customers",
    name: "Customers",
    Icon: FaUsers,
    allowed: ["Super Admin"],
  },
];

export const csuLinks: NavigationItem[] = [
  {
    id: "csu-dashboard",
    route: `/csu/dashboard`,
    name: "Dashboard",
    Icon: FaTachometerAlt,
    allowed: ["Admin"],
  },
  {
    id: "csu-account-opening",
    route: `#`,
    name: "Account Opening Requests",
    Icon: MdOutlineManageAccounts,
    allowed: ["User", "Admin"],
    children: [
      {
        id: "csu-account-individual",
        route: `/csu/account/individual`,
        name: "Individual Account",
        Icon: FaUserLock,
        allowed: ["User", "Admin"],
      },
      {
        id: "csu-account-corporate",
        route: `/csu/account/corporate`,
        name: "Corporate Account",
        Icon: FaLandmark,
        allowed: ["User", "Admin"],
      },
    ],
  },
  {
    id: "csu-account-upgrade",
    route: `/csu/account/upgrade`,
    name: "Account Upgrade Requests",
    Icon: FaStopwatch,
    allowed: ["User", "Admin"],
  },
  {
    id: "csu-returned",
    route: `/csu/returned`,
    name: "Returned for Correction",
    Icon: MdOutlineAssignmentReturned,
    allowed: ["User", "Admin"],
  },
];

export const hopLinks: NavigationItem[] = [
  {
    id: "hop-dashboard",
    route: `/hop/dashboard`,
    name: "Dashboard",
    Icon: FaTachometerAlt,
    allowed: ["Admin"],
  },
  {
    id: "hop-account-opening",
    route: `#`,
    name: "Account Opening Requests",
    Icon: MdOutlineManageAccounts,
    allowed: ["User", "Admin"],
    children: [
      {
        id: "hop-account-individual",
        route: `/hop/account/individual`,
        name: "Individual Account",
        Icon: FaUserLock,
        allowed: ["User", "Admin"],
      },
      {
        id: "hop-account-corporate",
        route: `/hop/account/corporate`,
        name: "Corporate Account",
        Icon: FaLandmark,
        allowed: ["User", "Admin"],
      },
    ],
  },
  {
    id: "hop-account-upgrade",
    route: `/hop/account/upgrade`,
    name: "Account Upgrade Requests",
    Icon: FaStopwatch,
    allowed: ["User", "Admin"],
  },
];

export const getNavigationLinks = (page?: string): NavigationItem[] => {
  switch (page) {
    case "Admin":
      return adminLinks;
    case "CSU":
      return csuLinks;
    case "HOP":
      return hopLinks;
    default:
      return adminLinks;
  }
};
